/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addScalarDependencies } from './dependenciesAddScalar.generated';
import { combinationsDependencies } from './dependenciesCombinations.generated';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated';
import { factorialDependencies } from './dependenciesFactorial.generated';
import { isIntegerDependencies } from './dependenciesIsInteger.generated';
import { isNegativeDependencies } from './dependenciesIsNegative.generated';
import { largerDependencies } from './dependenciesLarger.generated';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated';
import { powDependencies } from './dependenciesPow.generated';
import { subtractDependencies } from './dependenciesSubtract.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createStirlingS2 } from '../../factoriesAny.js';
export var stirlingS2Dependencies = {
  addScalarDependencies: addScalarDependencies,
  combinationsDependencies: combinationsDependencies,
  divideScalarDependencies: divideScalarDependencies,
  factorialDependencies: factorialDependencies,
  isIntegerDependencies: isIntegerDependencies,
  isNegativeDependencies: isNegativeDependencies,
  largerDependencies: largerDependencies,
  multiplyScalarDependencies: multiplyScalarDependencies,
  powDependencies: powDependencies,
  subtractDependencies: subtractDependencies,
  typedDependencies: typedDependencies,
  createStirlingS2: createStirlingS2
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesStirlingS2.generated.js
// module id = 526
// module chunks = 0